import React from 'react'
const Footer = () => {
    return (
        <div className="text-center bg-dark text-light" style={{ height: "8vh", alignItems: "center", padding: "15px" }}>
            <footer>Copyright &copy; News-India </footer>
        </div>
    )
}
export default Footer